<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

interface Props {
    translation: string
    field?: string
    centerElements?: boolean
}

const props = defineProps<Props>()

const { t } = useI18n()

const staticLanguages = ['en', 'de', 'da']
</script>

<template>
    <div
        class="text-xs print:text-xs/tight font-semibold text-primary-500 dark:text-primary-400 py-1 flex"
    >
        <span class="text-lg self-start font-semibold">
            {{ field ? field + '.' : '' }}
        </span>
        <div
            class="flex flex-col ml-3 text-left"
            :class="{
                '!text-center !mx-auto': props.centerElements,
            }"
        >
            <span
                v-for="lang in staticLanguages"
                :key="lang"
                class="font-semibold text-xs/tight"
                v-text="t(props.translation, 1, { locale: lang })"
            />
        </div>
    </div>
</template>
